export default () => ({
  itensOfNavigation: []
});
